package com.fireavert.gateways.gateway_dialog.client.data_models.requests

import kotlinx.serialization.Serializable

@Serializable
data class GatewayImageDeletionRequest(
    val gatewayId: String,
    val imageId: Int,
)
